import React from 'react';
import cn from 'classnames';
import { Button, ButtonProps } from '@odin-labs/components';
import { Copy } from 'containers/userPendingChange/helpers/languages';
import { Localize } from 'containers/userPendingChange/types';
import { ArrowRightIcon, TrashIcon } from 'components/icons';

export type StepActionsProps = {
  actions?: 'all' | 'continue' | 'skip';
  continueActionCopy?: Copy;
  continueActionIcon?: ButtonProps['icon'];
  continueActionEnabled?: boolean;
  continueActionWithSpinner?: boolean;
  cancelActionCopy?: Copy;
  cancelActionIcon?: ButtonProps['icon'];
  onContinue?: ButtonProps['onClick'];
  onCancel?: ButtonProps['onClick'];
  localize: Localize;
};

export const classes = {
  container: cn('odin-my-6 odin-grid odin-grid-cols-12 odin-gap-6'),
  button: (isHidden: boolean, extraClasses: string): string =>
    cn(
      extraClasses,
      'odin-justify-center odin-col-span-full sm:odin-col-span-6',
      isHidden && 'odin-hidden',
    ),
  skipButton: 'odin-order-2 sm:odin-order-1',
  continueButton: 'sm:odin-col-start-7 odin-order-1 sm:odin-order-2',
};

export function StepActions(props: StepActionsProps): React.ReactElement {
  const {
    localize,

    actions = 'all',
    onContinue,
    continueActionCopy = Copy.continue,
    continueActionIcon = ArrowRightIcon,
    continueActionEnabled = true,
    continueActionWithSpinner = false,

    onCancel,
    cancelActionCopy = Copy.cancel,
    cancelActionIcon = TrashIcon,
  } = props;

  const hideContinueAction = actions === 'skip';
  const hideSkipAction = actions === 'continue';

  const continueActionText = localize(continueActionCopy);
  const skipActionText = localize(cancelActionCopy);

  return (
    <div className={classes.container}>
      <Button
        onClick={onCancel}
        theme="danger"
        size="lg"
        text={skipActionText}
        icon={cancelActionIcon}
        className={classes.button(hideSkipAction, classes.skipButton)}
      />
      <Button
        onClick={onContinue}
        type="submit"
        size="lg"
        text={continueActionText}
        icon={continueActionIcon}
        className={classes.button(hideContinueAction, classes.continueButton)}
        disabled={!continueActionEnabled}
        withSpinner={continueActionWithSpinner}
      />
    </div>
  );
}
